/* eslint-disable import/prefer-default-export */
import {
    CheckoutDeliveryBasketQueryKey,
    GetBasketQueryKey,
    MiniBasketIndexQueryKey as GetMiniBasketQueryKey,
    PrizeCertificatesQueryKey,
    ProductDeliveryInfoViewModelQueryKey
} from 'autogen/swagger/all/hooks';
import { refreshBasketQuantityGlobally } from 'hooks/basket/useBasketQuantity';
import queryClient from 'setup/react-query/queryClient';

export function updateBasket() {
    queryClient.invalidateQueries({ queryKey: [GetBasketQueryKey] });
    queryClient.invalidateQueries({ queryKey: [GetMiniBasketQueryKey] });
    queryClient.invalidateQueries({ queryKey: [ProductDeliveryInfoViewModelQueryKey] });
    queryClient.invalidateQueries({ queryKey: [PrizeCertificatesQueryKey] });
    queryClient.invalidateQueries({ queryKey: [CheckoutDeliveryBasketQueryKey] });

    refreshBasketQuantityGlobally();
}
